import request from 'services/axios';

export const getMyWanteds = async (page: number, profile_type: string) => {
  const {data}: {data: IGetMyWanteds} = await request.get(
    `/api/v2/market/my-wanteds?page=${page}&profile_type=${profile_type}`,
  );
  return data;
};
